import type {LoanRequestOption} from 'src/typings';
import {getContext, setContext} from 'svelte';

const LOAN_REQUEST_FORM_CONTEXT_KEY = 'loan-request-form-context-key';

export interface LoanRequestFormContext {
    loginAndUpdateForm: () => Promise<void>;
    sendLoanRequest: (pathWithoutApiPrefix: string, loanRequestOption: LoanRequestOption) => Promise<void>;
}

export function setLoanRequestFormContext(loginAndUpdateForm: LoanRequestFormContext['loginAndUpdateForm'],
                                          sendLoanRequest: LoanRequestFormContext['sendLoanRequest']) {
    setContext(LOAN_REQUEST_FORM_CONTEXT_KEY, {loginAndUpdateForm, sendLoanRequest})
}

export function getLoanRequestFormContext(): LoanRequestFormContext {
    return getContext(LOAN_REQUEST_FORM_CONTEXT_KEY);
}